import React, { useState, } from 'react';
import { Alert, AlertTitle, Button, Grid, Paper, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { LOCAL_DATE_FORMAT } from '../../constants';


const SangatDetails = (props) => {

    const { history } = props;

    const [sangat, setSangat] = useState(props.location.state.sangat ? props.location.state.sangat : {});


    const addTraveller = () => {

        let traveller = { ...sangat, _id: null, user_firstName: "", user_middleName: "", user_lastName: "", user_gender: "", user_yearOfBirth: null, user_ride_from_airport: "" };;

        history.push({
            pathname: '/pending-user',
            state: { userToEdit: traveller }
        });
    }


    return (
        <div >

            <Alert  variant="filled"  color="success" sx={{ mr: 1, ml: 1 }} severity="success">
                <AlertTitle>Thank you for submitting your flight information.</AlertTitle>

            </Alert>
            <Paper sx={{ m: 1, p: 2 }} variant="outlined">

                <Grid container rowSpacing={1}>
                    <Grid item container alignItems="flex-end" xs={12}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }} >Personal Information </Typography>
                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Name: </Typography>
                        <Typography variant="body"> {sangat.user_firstName} {sangat.user_middleName} {sangat.user_lastName} </Typography>

                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>

                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Gender: </Typography>
                        <Typography variant="body"> {sangat.user_gender} </Typography>
                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Birthdate: </Typography>
                        <Typography variant="body"> {dayjs(sangat.user_yearOfBirth).format(LOCAL_DATE_FORMAT)} </Typography>
                    </Grid>



                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Asthan: </Typography>
                        <Typography variant="body"> {sangat.user_goingToAsthan} </Typography>

                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>

                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Country: </Typography>
                        <Typography variant="body"> {sangat.user_country} </Typography>
                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >State/Province: </Typography>
                        <Typography variant="body"> {sangat.user_state} </Typography>
                    </Grid>



                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >City: </Typography>
                        <Typography variant="body"> {sangat.user_city} </Typography>
                    </Grid>

                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Phone: </Typography>
                        <Typography variant="body"> {sangat.user_phoneNumber} </Typography>
                    </Grid>

                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Secondary Phone: </Typography>
                        <Typography variant="body"> {sangat.user_emergencyContact} </Typography>
                    </Grid>

                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Email: </Typography>
                        <Typography variant="body"> {sangat.user_email} </Typography>
                    </Grid>

                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Comments: </Typography>
                        <Typography variant="body"> {sangat.user_comments} </Typography>
                    </Grid>

                </Grid>


            </Paper>

            <Paper sx={{ m: 1, p: 2 }} variant="outlined">
                <Grid container rowSpacing={1}>

                    <Grid item container alignItems="flex-end" xs={12}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }} >Arriving Flight </Typography>
                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Need Ride: </Typography>
                        <Typography variant="body"> {sangat.user_ride_from_airport} </Typography>

                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Airline: </Typography>
                        <Typography variant="body"> {sangat.user_arrivingFlightName} </Typography>

                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>

                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Flight Number: </Typography>
                        <Typography variant="body"> {sangat.user_arrivingFlightNumber} </Typography>
                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Arrival Date: </Typography>
                        <Typography variant="body"> {dayjs(sangat.user_arrivingFlightDate).format(LOCAL_DATE_FORMAT)} </Typography>
                    </Grid>



                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Arrival Time: </Typography>
                        <Typography variant="body"> {sangat.user_arrivingFlightTime} </Typography>

                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>

                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Airport: </Typography>
                        <Typography variant="body"> {sangat.user_arrivingFlightAirport} </Typography>
                    </Grid>


                </Grid>


            </Paper>

            <Paper sx={{ m: 1, p: 2 }} variant="outlined">
                <Grid container rowSpacing={1}>
                    <Grid item container alignItems="flex-end" xs={12}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }} >Departing Flight </Typography>
                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Airline: </Typography>
                        <Typography variant="body"> {sangat.user_departingFlightName} </Typography>

                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>

                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Flight Number: </Typography>
                        <Typography variant="body"> {sangat.user_departingFlightNumber} </Typography>
                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Departure Date: </Typography>
                        <Typography variant="body"> {dayjs(sangat.user_departingFlightDate).format(LOCAL_DATE_FORMAT)} </Typography>
                    </Grid>



                    <Grid item container alignItems="flex-end" xs={12} md={4}>
                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Departure Time: </Typography>
                        <Typography variant="body"> {sangat.user_departingFlightTime} </Typography>
                        
                    </Grid>
                    <Grid item container alignItems="flex-end" xs={12} md={4}>

                        <Typography mr={2} variant="body" sx={{ fontWeight: 'bold' }} >Airport: </Typography>
                        <Typography variant="body"> {sangat.user_departingFlightAirport} </Typography>
                    </Grid>


                </Grid>

            </Paper>
            <Grid container justifyContent="flex-end">

                <Button variant="contained" sx={{ mr: 1 }} onClick={addTraveller}>Add Another Traveller</Button>
            </Grid>
        </div>
    )

}


export default SangatDetails;